// PAGES
import processes_page from './processes/processes.js';
import all_processes from './processes/sub-pages/all.js';

export default [
	processes_page,
	all_processes,
];
